module.exports = __webpack_public_path__ + "img/slider_arrow_left.6d0c9ce6.svg";